'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconHammer, iconHammerTag } from '@ni/nimble-components/dist/esm/icons/hammer';
import { wrap } from '../../utilities/react-wrapper';

export type { IconHammer };
export { iconHammerTag };
export const NimbleIconHammer = wrap(IconHammer);